import {
  getToken,
  setToken,
  removeToken,
  getRoles,
  setRoles,
  removeRoles
} from "@/util/auth";

const user = {
  state: {
    token: getToken(),
    user: {},
    roles: getRoles() || [], // 角色列表, ROLE_CYY_USER 产业园; ROLE_GOVERNMENT
    clientid: "", // ==20008 时 隐藏“古荔资源”菜单，点击“应用中心”链接到地址http://36.133.149.117:8001/ywtg
    // 第一次加载菜单时用到
    loadMenus: false
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_USER: (state, user) => {
      state.user = user;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_CLIENTID: (state, v) => {
      state.clientid = v;
    },
    SET_LOAD_MENUS: (state, loadMenus) => {
      state.loadMenus = loadMenus;
    }
  },

  actions: {
    mdLogin({ commit }, res) {
      setToken(res.token, false);
      commit("SET_TOKEN", res.token);
      setUserInfo(res.user, commit);
      // 第一次加载菜单时用到， 具体见 src 目录下的 permission.js
      commit("SET_LOAD_MENUS", true);
    },

    // 登出
    LogOut({ commit }) {
      return new Promise(resolve => {
        commit("SET_TOKEN", "");
        commit("SET_ROLES", []);
        removeToken();
        removeRoles();
        resolve();
      });
    },

    updateLoadMenus({ commit }) {
      return new Promise(() => {
        commit("SET_LOAD_MENUS", false);
      });
    }
  }
};

export const setUserInfo = (res, commit) => {
  // 如果没有任何权限，则赋予一个默认的权限，避免请求死循环
  if (res.roleInfo) {
    if (res.roleInfo.roles.length === 0) {
      commit("SET_ROLES", ["ROLE_SYSTEM_DEFAULT"]);
    } else {
      let roles = res.roleInfo.roles.map(e => {
        return e.code;
      });
      setRoles(roles);
      commit("SET_ROLES", roles);
    }
  }
  commit("SET_USER", res);
};

export default user;
